import { render } from "./MarketTile.vue?vue&type=template&id=78513a97&scoped=true"
import script from "./MarketTile.vue?vue&type=script&lang=js"
export * from "./MarketTile.vue?vue&type=script&lang=js"

import "./MarketTile.vue?vue&type=style&index=0&id=78513a97&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78513a97"]])

export default __exports__